/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentAddCommandResultValidationResult } from './DocumentAddCommandResultValidationResult';
import {
	DocumentAddCommandResultValidationResultFromJSON,
	DocumentAddCommandResultValidationResultFromJSONTyped,
	DocumentAddCommandResultValidationResultToJSON,
	DocumentAddCommandResultValidationResultToJSONTyped,
} from './DocumentAddCommandResultValidationResult';
import type { DocumentFeatureValuesResult } from './DocumentFeatureValuesResult';
import {
	DocumentFeatureValuesResultFromJSON,
	DocumentFeatureValuesResultFromJSONTyped,
	DocumentFeatureValuesResultToJSON,
	DocumentFeatureValuesResultToJSONTyped,
} from './DocumentFeatureValuesResult';

/**
 *
 * @export
 * @interface DocumentAddCommandResult
 */
export interface DocumentAddCommandResult {
	/**
	 *
	 * @type {string}
	 * @memberof DocumentAddCommandResult
	 */
	caseId?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof DocumentAddCommandResult
	 */
	documentId?: string | null;
	/**
	 *
	 * @type {Array<DocumentAddCommandResultValidationResult>}
	 * @memberof DocumentAddCommandResult
	 */
	validationResults?: Array<DocumentAddCommandResultValidationResult> | null;
	/**
	 *
	 * @type {Date}
	 * @memberof DocumentAddCommandResult
	 */
	creationDate?: Date | null;
	/**
	 *
	 * @type {DocumentFeatureValuesResult}
	 * @memberof DocumentAddCommandResult
	 */
	documentFeatureValues?: DocumentFeatureValuesResult;
}

/**
 * Check if a given object implements the DocumentAddCommandResult interface.
 */
export function instanceOfDocumentAddCommandResult(
	value: object
): value is DocumentAddCommandResult {
	return true;
}

export function DocumentAddCommandResultFromJSON(json: any): DocumentAddCommandResult {
	return DocumentAddCommandResultFromJSONTyped(json, false);
}

export function DocumentAddCommandResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DocumentAddCommandResult {
	if (json == null) {
		return json;
	}
	return {
		caseId: json['caseId'] == null ? undefined : json['caseId'],
		documentId: json['documentId'] == null ? undefined : json['documentId'],
		validationResults:
			json['validationResults'] == null
				? undefined
				: (json['validationResults'] as Array<any>).map(
						DocumentAddCommandResultValidationResultFromJSON
					),
		creationDate: json['creationDate'] == null ? undefined : new Date(json['creationDate']),
		documentFeatureValues:
			json['documentFeatureValues'] == null
				? undefined
				: DocumentFeatureValuesResultFromJSON(json['documentFeatureValues']),
	};
}

export function DocumentAddCommandResultToJSON(json: any): DocumentAddCommandResult {
	return DocumentAddCommandResultToJSONTyped(json, false);
}

export function DocumentAddCommandResultToJSONTyped(
	value?: DocumentAddCommandResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		caseId: value['caseId'],
		documentId: value['documentId'],
		validationResults:
			value['validationResults'] == null
				? undefined
				: (value['validationResults'] as Array<any>).map(
						DocumentAddCommandResultValidationResultToJSON
					),
		creationDate:
			value['creationDate'] == null ? value['creationDate'] : value['creationDate'].toISOString(),
		documentFeatureValues: DocumentFeatureValuesResultToJSON(value['documentFeatureValues']),
	};
}
